<ng-container *transloco="let _t">


<incident-list #incList
	[incidents]="incidents"
	(openTriggered)="showIncident($event)">
</incident-list>

</ng-container>